"use strict";
/* eslint-disable no-plusplus */
/**
 * Lenses for JSON data.
 *
 * @module
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.findImpl = exports.replaceImpl = exports.withDefaultImpl = exports.indexImpl = exports.keyImpl = void 0;
const utils_1 = require("./utils");
const base_1 = require("./base");
const simple_cache_1 = require("./simple-cache");
function keyImpl(k) {
    return k === undefined
        ? // type-safe key
            (k) => keyCache.getOrCreate(k)
        : // untyped key
            keyCache.getOrCreate(k);
}
exports.keyImpl = keyImpl;
function indexImpl(i) {
    if (i < 0)
        throw new TypeError(`${i} is not a valid array index, expected >= 0`);
    return indexCache.getOrCreate(i);
}
exports.indexImpl = indexImpl;
function withDefaultImpl(defaultValue) {
    // @TODO is this cast safe?
    return base_1.Lens.replace(undefined, defaultValue);
}
exports.withDefaultImpl = withDefaultImpl;
function choose(getLens) {
    return base_1.Lens.create((s) => getLens(s).get(s), (v, s) => getLens(s).set(v, s));
}
function replaceImpl(originalValue, newValue) {
    return base_1.Lens.create(x => (utils_1.structEq(x, originalValue) ? newValue : x), utils_1.conservatively((y) => (utils_1.structEq(y, newValue) ? originalValue : y)));
}
exports.replaceImpl = replaceImpl;
function findImpl(predicate) {
    return choose((xs) => {
        const i = utils_1.findIndex(xs, predicate);
        return i < 0 ? base_1.Lens.nothing() : base_1.Lens.index(i);
    });
}
exports.findImpl = findImpl;
base_1.Lens.key = keyImpl;
base_1.Lens.index = indexImpl;
base_1.Lens.withDefault = withDefaultImpl;
base_1.Lens.replace = replaceImpl;
base_1.Lens.find = findImpl;
const keyCache = new simple_cache_1.SimpleCache(key => base_1.Lens.create(s => s[key], (v, s) => utils_1.setKey(key, v, s)));
const indexCache = new simple_cache_1.SimpleCache(i => base_1.Prism.create(xs => xs[i], (v, xs) => {
    if (xs.length <= i) {
        return xs.concat(Array(i - xs.length), [v]);
    }
    else if (utils_1.structEq(v, xs[i])) {
        return xs;
    }
    else {
        return xs.slice(0, i).concat([v], xs.slice(i + 1));
    }
}));
